import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { Icon } from "antd";
import { parterLogo } from "../data/Common/parterLogo";
import { multiLanguage, withRedux } from "../hoc";

const mapStateToProps = (state) => {
  return state;
};

const actionToProps = {};

@multiLanguage()
@withRedux(mapStateToProps, actionToProps)
class FooterBar extends Component {
  state = {
    openToggle: false,
  };
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  handleToggle = () => {
    const { openToggle } = this.state;
    this.setState({
      openToggle: !openToggle,
    });
  };
  render() {
    const { openToggle } = this.state;
    const { t } = this.props;
    return (
      <div className="footer-bar">
        {openToggle && (
          <div className="associated-sites">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="menu-box">
                    <ul>
                      <li>
                        <strong>{t("Property")}</strong>
                      </li>
                      {_.map(parterLogo, (item, key) => {
                        if (item.property === true) {
                          return (
                            <li>
                              <a href={item.link}>{item.name}</a>
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col">
                  <div className="menu-box">
                    <ul>
                      <li>
                        <strong>{t("Non-Property")}</strong>
                      </li>
                      {_.map(parterLogo, (item, key) => {
                        if (item.property !== true) {
                          return (
                            <li>
                              <a href={item.link}>{item.name}</a>
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-md-7">
              <ul className="container-footer-bar">
                <li className="container-footer-bar-menu">
                  <a href="https://lagunaproperty.com/en/sitemap">
                    {t("Site Map")}
                  </a>
                </li>
                <li className="container-footer-bar-menu">
                  <a href="https://lagunaproperty.com/en/terms">
                    {t("Term of Use")}
                  </a>
                </li>
                <li className="container-footer-bar-menu">
                  <a href="https://lagunaproperty.com/en/privacy-policy">
                    {t("Privacy Policy")}
                  </a>
                </li>
                <li className="d-md-none">
                  <a onClick={this.handleToggle}>
                    {t("Associated sites")}
                    <span className="icon-arrow">
                      {openToggle === true ? (
                        <Icon type="caret-down" />
                      ) : (
                        <Icon type="caret-up" />
                      )}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-5">
              <div className="container-rights">
                © Laguna Property 2022 all rights reserved
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FooterBar;



// WEBPACK FOOTER //
// ./src/components/FooterBar.js